/*SYSTEM IMPORTS*/
    import React, { Component } from 'react'

/*VIEWS*/
    // import Link from 'components/Link'

/*API*/
    import { Helpers } from 'api'

/*HELPERS*/
    import { ConnectReduxWith } from 'helpers/Redux/connectRedux'

@ConnectReduxWith( 'settings' )
class Footer extends Component {
    render() {
        const { settings = false } = this.props

        const { system_settings = {} } = settings

        const { footer = {} } = system_settings

        const { logo = [], copyright = '' } = footer

        return (
            <footer key={ 'footer' }>
                <div className="container"> 
                    <a href="#" className="logo">
                        { logo.length > 0 &&  <img src={`${ Helpers.GetImage( logo[0], 'full' ) }`} alt=""/> }

                        <span className="copyright">
                            { copyright }
                        </span>
                    </a>
                    <a href="http://bolt-system.ru/" target="_blank" className="bolt-system">
                        <span>
                            Разработка и поддержка: 
                        </span>
                        <img src="/theme/frontend/img/bolt-system.png" alt="" />
                    </a>
                </div>
            </footer>
        )
    }
}

export default Footer